import { Component, ViewChild, OnInit } from '@angular/core';
import { PatientSearch } from '../../../model/patient/patient-search';
import { PatientViewComponent } from '../../patient-view/patient-view.component';
import { WizardStep } from '../../../wizard/wizard.component';
import { ReservationWizardService } from '../../../services/wizard/reservation/reservation.wizard.service';
import { PatientSearchComponent } from '../../patient-search/patient-search.component';
import { MatDialog } from '@angular/material';
import { PatientService } from '../../../services/patient.service';
import { NotificationToastService } from 'src/app/services/notification-toast.service';
import { PatientReservationMessageService } from 'src/app/services/patient-reservation-message.service';

@Component({
  selector: 'app-reservation-patient-component',
  templateUrl: './reservation-patient.component.html',
  styleUrls: ['./reservation-patient.component.css']
})
export class ReservationPatientComponent implements OnInit, WizardStep {

  isInit: boolean;
  public patientSearched = false;
  patient: PatientSearch;

  @ViewChild('patientViewComponent', {static: false}) patientViewComponent: PatientViewComponent;
  @ViewChild('patientSearch', {static: false}) patientSearch: PatientSearchComponent;

  constructor(
    private patientReservationMessageService: PatientReservationMessageService,
    public reservationWizardService: ReservationWizardService) {
    this.patient = this.reservationWizardService.reservation.Patient;
    if (this.patient != null) {
      this.patientSearched = true;
    }
  }

  get completed(): boolean { return this.isValid(); }

  isValid() {
      return true;
  }

  save() {
     this.reservationWizardService.firstNameSearh = this.patientSearch.getFirstNameSearch();
     this.reservationWizardService.lastNameSearh = this.patientSearch.getLastNameSearch();
     this.reservationWizardService.documentSearh = this.patientSearch.getDocumentSearch();
  }

    get valid(): boolean {
    return this.completed;
  }


  async activate() {
    this.patient = this.reservationWizardService.reservation.Patient;
    if (this.patient != null) {
      this.patientSearched = true;
    }

     setTimeout(() => this.patientSearch.setFocus(), 100);
  }

  onPatientSelected(patientSearch: PatientSearch) {
    if (! this.patient ||  this.patient.Id !== patientSearch.Id) {
      this.patientReservationMessageService.showReservationAlertIfRequired(patientSearch.Id);
    }
    this.patientSearched = true;
    this.patient = patientSearch;
    this.reservationWizardService.setPatient(this.patient);
  }

  ngOnInit() {
    this.isInit = true;
    this.activate();
  }
}
